// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2gLJ6","label":"SetPasswdForm_label__2_5dq"};